import { Component, OnInit, Input, Output, EventEmitter, Self } from '@angular/core';
import { NgControl, AbstractControl, Validators } from '@angular/forms';
import { VendorService } from 'src/app/services/vendor.service';


@Component({
  selector: 'multiselect-vendor',
  templateUrl: './multiselect-vendor.component.html',
  styleUrls: ['./multiselect-vendor.component.scss']
})
export class MultiselectVendorComponent implements OnInit {

  @Input() fieldError: string;
  @Input() label = 'Vendors';
  @Input() required: boolean;
  @Input() isSubmitted: boolean;

  @Output() updated: EventEmitter<any> = new EventEmitter();

  // params
  animate = false;
  isOpen = false;

  // options
  options: any;

  selectedValues = [];

  value: string = 'All';

  constructor(
    private _vendorSvc: VendorService,
    @Self() public ngCtrl: NgControl
  ) {
    ngCtrl.valueAccessor = this;
  }

  ngOnInit(): void {

    this._vendorSvc.getVendors();
    this._vendorSvc.Vendors.subscribe((res: any) => {
      if (res) {
        this.options = res;
      }
    });

    this.updateValue();

  }

  /**
   * Update field value
   */
  updateValue(): void {

    const numValues = this.selectedValues.length;

    if (numValues === 0) {
      this.value = 'All';
      this.onChange('All');
    } else {
      this.value = `${numValues} selected`;
      this.onChange(this.selectedValues);
    }

  }

  /**
   * Checkbox click event handler
   * @param e
   * @param id
   */
  onCheck(e: any, id: number): void {

    e.preventDefault();
    e.stopPropagation();

    const tgt = e.target;

    // update selected values
    if (this.selectedValues.includes(id)) {
      const valueIndex = this.selectedValues.indexOf(id)
      this.selectedValues.splice(valueIndex, 1);
      tgt.checked = false;
    } else {
      this.selectedValues.push(id);
      tgt.checked = true;
    }

    this.updateValue();

  }

  /**
   * On select all checkbox click event handler
   * @param e
   */
  onSelectAll(e: any): void {

    e.preventDefault();
    e.stopPropagation();
    this.selectedValues.length = 0;
    this.updateValue();

  }

  /**
   * Open menu event handler
   */
  openMenu(): void {

    setTimeout(() => {

      this.isOpen = true;
      setTimeout(() => {
        this.animate = true;
      }, 100);

    }, 100);

  }

  /**
   * Close menu event handler
   */
  closeMenu(): void {
    this.animate = false;
    this.isOpen = false;
  }

  /**
   * Closes the menu if tab key is pressed
   * @param e
   */
  onKeyup(e: any): void {

    if (e.keyCode === 9) {
      this.closeMenu();
    }

  }

  // control value accessor params

  onChange(_value: any) {}

  onTouched() {}

  writeValue(_value: any) {

  }

  registerOnChange(fn: (value: any) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  validate(ctrl: AbstractControl) {
    return Validators.required(ctrl);
  }

}
